import React, { useEffect, useMemo, useState } from "react";
import { useManualUpdate, useStockReportData } from "./store";
import StockReportTable from "./StockReportTable";

function StockReport() {
  const [selectedSku, setSelectedSku] = useState("");
  const { stockReportData, reportLoading, fetchStockReport } =
    useStockReportData();
  const { wareHousesData, fetchWareHouses } = useManualUpdate();

  useEffect(() => {
      fetchWareHouses();
  }, []);

  useEffect(() => {
      fetchStockReport("", selectedSku);
  }, [selectedSku]);

  const warehouses = useMemo(() => {
    return wareHousesData?.map((item) => ({
      value: item.id,
      label: item.name,
    }));
  }, [wareHousesData]);

  return (
    <div className="d-flex flex-column gap-3">
      <StockReportTable
        isLoading={reportLoading}
        stockReportData={stockReportData}
        setSelectedSku={setSelectedSku}
        warehouses={warehouses}
      />
    </div>
  );
}

export default StockReport;
